import { ChangeEvent, useState } from "react";
import SupplierService from "../../services/SupplierService";
import ISupplierSettings from "../../models/ISupplierSettings";
import IInvoiceViewOptions from "../../models/IInvoiceViewOptions";

export const useInvoiceViewOptions = (
    supplierSettings: ISupplierSettings
): [IInvoiceViewOptions, (e: React.ChangeEvent<HTMLInputElement>) => void, React.Dispatch<React.SetStateAction<IInvoiceViewOptions>>] => {
    const [viewOptions, setViewOptions] = useState<IInvoiceViewOptions>({
        hideBusinessName: SupplierService.getSupplierSetting(supplierSettings, "hide_business_name", false, "invoice"),
        inlineLogoName: SupplierService.getSupplierSetting(supplierSettings, "inline_logo_name", false, "invoice"),
        showSku: SupplierService.getSupplierSetting(supplierSettings, "show_sku", true, "invoice"),
        showSkuBarcode: SupplierService.getSupplierSetting(supplierSettings, "show_sku_barcode", false, "invoice"),
        showDescription: SupplierService.getSupplierSetting(supplierSettings, "show_description", true, "invoice"),
        showPhone: SupplierService.getSupplierSetting(supplierSettings, "show_phone", true, "invoice"),
        showEmail: SupplierService.getSupplierSetting(supplierSettings, "show_email", true, "invoice"),
        showUom: SupplierService.getSupplierSetting(supplierSettings, "show_uom", true, "invoice"),
        showOrderQty: SupplierService.getSupplierSetting(supplierSettings, "show_order_qty", true, "invoice"),
        showUnitPrice: SupplierService.getSupplierSetting(supplierSettings, "show_unit_price", true, "invoice"),
        showBillTo: SupplierService.getSupplierSetting(supplierSettings, "show_bill_to", true, "invoice"),
        showBillToPhone: SupplierService.getSupplierSetting(supplierSettings, "show_bill_to_phone", false, "invoice"),
        showShipToPhone: SupplierService.getSupplierSetting(supplierSettings, "show_ship_to_phone", false, "invoice"),
        showOrderUser: SupplierService.getSupplierSetting(supplierSettings, "show_order_user", false, "invoice"),
    });

    const handleViewOptionChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setViewOptions((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return [viewOptions, handleViewOptionChange, setViewOptions];
};
